import { Card } from '../models/card';

export const emptyCard: Card = {
    attn: '',
    organization: '',
    street1: '',
    street2: '',
    street3: '',
    city: '',
    country: '',
    province: '',
    postalCode: '',
    residentialFlag: false,
    telephone: '',
    email: '',
    openTime: '',
    closeTime: ''
};
